// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';

import steleActions from '../../actions/stele-actions.js';

import * as config from '../../../../config.js';
import T from '../../../../nls/translate.js';

const disabledStyle = {opacity: '0.4', pointerEvents: 'none'};

function onNoCharging() {
	steleActions.setChargingCount(0);
}
function on1Charging() {
	steleActions.setChargingCount(1);
}
function on2Charging() {
	steleActions.setChargingCount(2);
}
function on3Charging() {
	steleActions.setChargingCount(3);
}
function onBasic() {
	steleActions.setChargingType(config.C_TYPE_BASIC);
}
function onAdv() {
	steleActions.setChargingType(config.C_TYPE_ADV);
}
function onProf() {
	steleActions.setChargingType(config.C_TYPE_PROF);
}
function on3k7() {
	steleActions.setChargingPower(config.C_POWER_3k7);
}
function on11k() {
	steleActions.setChargingPower(config.C_POWER_11k);
}
function on22k() {
	steleActions.setChargingPower(config.C_POWER_22k);
}


export default function (charging) {
	const c = charging;
	return (
		<div className={'slx-stele-summary-line-accesory slx-stele-summary-line slx-stele-summary-line__'  + config.PART_MODUL_CHARGING_NAME} >
			<span className="slx-stele-summary-line__title">{T.current.PRODUCTS.baseDescription[config.PART_MODUL_CHARGING_NAME]}</span>
			<img className="slx-stele-summary-line__icon" src={config.PART_MODUL_CHARGING.getImg()} />
			<div className="slx-stele-summary-line__details">
				<div className="slx-stele-summary__charging" >
					<div className="slx-stele-summary__optiongroup" style={{paddingLeft: '16px'}} >
						<div className={c.count === 0 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={onNoCharging} >
							<span className="slx-stele-summary__option-text">0</span>
						</div>
						<div className={c.count === 1 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={on1Charging} >
							<span className="slx-stele-summary__option-text">1</span>
						</div>
						<div className={c.count === 2 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={on2Charging} >
							<span className="slx-stele-summary__option-text">2</span>
						</div>
						<div className={c.count === 3 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={on3Charging} >
							<span className="slx-stele-summary__option-text">3</span>
						</div>
					</div>
					<div className="slx-stele-summary__optiongroup" style={c.count === 0 ? disabledStyle : null} style={{paddingLeft: '0px'}} >
						<div className={c.type === config.C_TYPE_BASIC ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={onBasic} >
							<span className="slx-stele-summary__option-textwide">{T.current.SUMMARY.CHARGING_BASIC}</span>
						</div>
						<div className={c.type === config.C_TYPE_ADV ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={onAdv} >
							<span className="slx-stele-summary__option-textwide">{T.current.SUMMARY.CHARGING_ADV}</span>
						</div>
						<div className={c.type === config.C_TYPE_PROF ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={onProf} >
							<span className="slx-stele-summary__option-textwide">{T.current.SUMMARY.CHARGING_PROF}</span>
						</div>
					</div>
					<div className="slx-stele-summary__optiongroup" style={c.count === 0 ? disabledStyle : null} style={{paddingLeft: '16px'}} >
						<div className={c.power === config.C_POWER_3k7 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={on3k7} >
							<span className="slx-stele-summary__option-text">{'3'+T.current.MATH.FRACTION+'7kW'}</span>
						</div>
						<div className={c.power === config.C_POWER_11k ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={on11k} >
							<span className="slx-stele-summary__option-text">11kW</span>
						</div>
						<div className={c.power === config.C_POWER_22k ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={on22k} >
							<span className="slx-stele-summary__option-text">22kW</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

